export const SERVER_URL = "https://peerwatch-backend.herokuapp.com";
export const LOCAL_SERVER_URL = "http://localhost:8080";
export const FALLBACK_VID = "https://www.youtube.com/watch?v=pdCaVAPZLXM";
